import { render, staticRenderFns } from "./test-lightbox.vue?vue&type=template&id=1865a0cd&scoped=true&"
import script from "./test-lightbox.vue?vue&type=script&lang=js&"
export * from "./test-lightbox.vue?vue&type=script&lang=js&"
import style0 from "./test-lightbox.vue?vue&type=style&index=0&id=1865a0cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1865a0cd",
  null
  
)

export default component.exports